




























import { Component, Vue } from 'vue-property-decorator'
import Login from '@/components/Login/Login.vue'
import ForgotPassword from '@/components/Login/ForgotPassword.vue'
import ResetPassword from '@/components/Login/ResetPassword.vue'
import { Icon } from '@alpha/ink'

interface ToggleModeData {
  mode: 'login' | 'forgot' | 'reset'
  message: string
}

@Component({ components: { Login, ForgotPassword, ResetPassword, Icon } })

export default class LoginPage extends Vue {
  mode: 'login' | 'forgot' | 'reset' = 'login'
  email: string = ''
  token: string = ''
  uid: string = ''
  message: string = ''
  loading: boolean = true

  blogContent = [
  ]

  mounted () {
    if (this.$route.query.token) {
      this.mode = 'reset'
    } else {
      this.loading = false
    }
  }

  toggleMode (data?: ToggleModeData) {
    if (data && data.mode) {
      this.mode = data.mode
    } else {
      this.mode = this.mode === 'login' ? 'forgot' : 'login'
    }
    this.message = data && data.message ? data.message : this.message
  }
}
